<template>
    <div class="HistoryDetailsComponent">
        <p v-if="revisionId == ''">{{ lang.infotext_1 }}</p>
        <div v-if="revisionId != ''">

            <p v-if="comments.length == 0">{{ lang.infotext_3 }}</p>

            <div class="list-details" v-if="comments.length > 0">
                <p>{{ lang.infotext_2 }}:</p>
                <b-list-group>


                    <div v-for="comment in comments" :key="comment.id">
                        <b-list-group-item>
                            <p>{{ longDateToShort(comment.creationDate) }} | {{ comment.login }}</p>
                            <p v-show="comment.type == 'reason'">{{ lang.label_Reason }}:</p>
                            <p v-show="comment.type == 'comment'">{{ lang.label_Comment }}:</p>
                            <p v-show="comment.type == 'transfer'">{{ lang.label_Transfer }}:</p>
                            <p class="task-reason-text">{{ comment.comment }}</p>
                        </b-list-group-item>

                    </div>


                </b-list-group>
            </div>


        </div>


    </div>
</template>

<script>

import * as Tools from '@/Tools/Tools';


export default {
    name: "HistoryDetailsComponent",
    props: {
        lang: Object,
        
    },
    components: {

        
    },
    data() {
        return {
            name: "HistoryDetailsComponent",
            comments: [],
            
        }
    },
    computed: {
        
        revisionId() {
            let revisionId = "";
            
            const tab = this.$store.getters.selectedRevisionRow
            let rev = 0;
            let revId = "";
            for (let i = 0, lei = tab.length; i < lei; i++) {

                if (tab[i].revision > rev) {
                    rev = tab[i].revision;
                    revId = tab[i].revisionId;
                }

            }


            revisionId = revId;
            

            return revisionId;

        },
        lastRevisionHistory() {

            let tab = this.$store.getters.revisionHistory;
            let obj = tab[0];
            for (let i = 0, lei = tab.length; i < lei; i++) {

                if (tab[i].revision > obj.revision) {
                    obj = tab[i];
                }
            }

            return obj;
        },
        selectedLastRevisionRow() {
            if (this.parent == "table") {
                return true;
            }
            if (this.$store.getters.selectedRevisionRow.length == 0) {
                return false;
            }
            return this.$store.getters.selectedRevisionRow[0].revisionId == this.lastRevisionHistory.id;
        },
        
        reloadedAfterActionComplex() {
            return this.$store.getters.reloadedAfterActionComplex;
        },
        
    },
    created() {


        this.getComments();


    },
    watch: {
        revisionId: function () {


            this.getComments();


        },
        
        reloadedAfterActionComplex: {
            handler: function (newValue) {
                
                for (let el in newValue) {
                    
                    if (newValue[el].name == this.name) {

                        if (newValue[el].status == true) {

                            this.getComments(this);

                            newValue[el].status = false;

                            this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
                        }
                    }
                }
            },
            deep: true

        },
    },
    
    methods: {
        longDateToShort(date) {
            return Tools.longDateToShort(date);
        },
        getComments() {

            let vue = this;

            const obj = {
                revisionId: this.revisionId
            }

            this.$store.dispatch(this.$store.getters.sectionPrefix + "_getHistoryComments", obj)
                .then((result) => {

                    console.log(result)
                    if (result.status == "OK") {

                        vue.comments = result.data
                        for (let i = 0, lei = vue.comments.length; i < lei; i++) {

                            if (vue.comments[i].reason == null) {
                                vue.comments[i].reason = "";
                            }
                            if (vue.comments[i].comment == null) {
                                vue.comments[i].comment = "";
                            }
                        }

                        
                    }


                })
        },
        
        

    }


}
</script>
<style lang="scss">
.HistoryDetailsComponent {
    .task-buttons {
        margin-left: 50px;

    }

    .task-reason-text {
        margin-left: 20px;
    }

    .list-group-item {
        margin-top: 5px;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/shared/HistoryDetailsComponent.vue